/**
 * In the status bar of every layout while a flow is playing: which flow is
 * choosing the songs, so it is plain that it carries on when Flow is not on
 * screen. Click to go back to it.
 */

import { useApp } from "../core/app";
import { useFlow } from "./useFlowEditor";

export function FlowStatus() {
  const app = useApp();
  const f = useFlow();
  // Flow lives in the core layouts; in any other (a plugin's) it is not on screen.
  const coreLayout = app.layout === "pro" || app.layout === "compact";
  if (!f?.live || (app.nav.view === "flow" && coreLayout)) return null;
  return (
    <button className="nv-link" title="The open flow chooses what plays next. Click to see it."
      onClick={() => { if (!coreLayout) app.setLayout("pro"); app.navigate("flow"); }}>
      Flow: {f.name || "Untitled flow"}{f.dirty ? " (unsaved)" : ""} · choosing the songs
    </button>
  );
}
